import { styled } from '@mui/material/styles';
import { Accordion, Button, Dialog, IconButton, Paper } from '@mui/material';
import { COLOR, TEXT_BUTTON_COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

const StyledVoices = styled('div')`
  .MuiDialogContent-root {
    height: 700px;
  }
  .content {
    display: flex;
  }
  .MuiDialogContent-root {
    padding: 0;
  }
  overflow: hidden;
  .voice-list {
    display: grid;
    gap: 10px;
    padding-top: 12px;
    width: 817px;
    padding-right: 20px;
  }
  .with-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
  @media only screen and (min-width: ${MOBILE_BREAKPOINT}) {
    .web {
      display: flex;
      padding: 0;
    }

    .voice-content {
      width: ${(props) => (props.openSearch ? 'calc(100%)' : '100%')};
      padding-left: 24px;
      padding-top: 16px;
      border-top: 1px solid ${COLOR.phoneInput};
      border-right: 1px solid ${COLOR.phoneInput};
      padding-right: 5px;
    }

    .voice-detail {
      display: flex;
      width: ${(props) => props.openSearch && 'calc(100% / 5)'};
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .web {
      display: none;
    }

    .voice-content {
      width: ${(props) => (props.openSearch ? 'calc(100%)' : '100%')};
    }
  }
  .MuiTypography-title1 {
    color: ${COLOR.darkGray};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: -0.4px;
  }

  .voice-container {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 565px;
  }
  .not-found-voice {
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;
  }

  .text-not-found {
    color: ${COLOR.label2[64]};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.2px;
    margin: 0px;
    padding-top: 12px;
  }
  .voice-info-skeleton {
    border-radius: 16px;
    flex: 1px;
    border-color: ${COLOR.white};
    text-transform: capitalize;
    background: #f5f5f5;
    align-items: center;
    text-align: center;
    width: 265px;
    height: 168px;
  }
  .voice-name-skeleton {
    color: ${COLOR.darkGray};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 510;
    line-height: 24px;
    letter-spacing: -0.4px;
    padding-right: 20px;
    padding-left: 20px;
  }
  .avartar-skeleton {
    padding-top: 35px;
  }
  .features-skeleton {
    color: ${COLOR.label2[64]};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    padding-right: 20px;
    padding-left: 20px;
  }
`;

const StyledTableScrollbar = styled('div')`
  width: 100%;
  .hidden-scrollbar {
    &::-webkit-scrollbar {
      width: 4px;
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      width: 4px;
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar {
      width: 4px;
      background: ${COLOR.white};
    }
  }

  .small-scrollbar {
    &::-webkit-scrollbar {
      width: 8px;
      height: 107px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.indigo[64]};
      height: 107px;
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.indigo[80]};
      border-radius: 100px;
    }
  }
`;

const StyledImg = styled('div')`
  margin: 0px;
  .css-bhwwdj {
    padding: 0px;
  }
`;
const StyledVoiceItem = styled(Button)`
  color: ${COLOR.text};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 265px;
  height: 168px;
  border-style: solid;
  border-color: ${(props) => (props.active ? COLOR.primary : COLOR.white)};
  text-transform: capitalize;
  opacity: ${(props) => (props.disabledVoice ? 0.6 : 1)};
  background: ${(props) =>
    props.active ? TRANSPARENT_COLOR.primary : '#f5f5f5'};
  transition: none;
  &:hover {
    border: none;
    border-color: ${(props) => (props.active ? '' : COLOR.white)};
    color: ${(props) => (props.active ? COLOR.darkBlue : COLOR.text)};
    background: ${(props) => (props.active ? '' : 'rgba(30, 22, 78, 0.16)')};
    .MuiAvatar-img {
      filter: brightness(0.8);
      transition: none;
    }
  }

  &:focus {
    border: none;
    border-color: ${(props) => (props.active ? '' : COLOR.white)};
    background: ${(props) =>
      props.active ? TRANSPARENT_COLOR.primary : COLOR.white};
    .MuiAvatar-img {
      filter: brightness(0.8);
      transition: none;
    }
  }
  .voice-info {
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: center;
    width: 216px;
    .avatar .MuiAvatar-img {
      filter: brightness(0.6);
      transition: opacity 0.3s ease;
    }
  }
  .audio-player {
    width: 72px;
    height: 72px;
  }
  .voice-name {
    color: ${COLOR.darkGray};
    text-align: center;
    font-family: 'SF Pro';
    font-size: 16px;
    font-style: normal;
    font-weight: 510;
    line-height: 24px;
    letter-spacing: -0.4px;
  }

  .features {
    color: ${COLOR.label2[64]};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
  .avatar-wrapper {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 72px;
    height: 72px;
  }
  .progress-play-audio {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 72px;
    height: 72px;
    transform: rotate(-90deg);
  }

  .avatar {
    position: relative;
    width: 72px;
    height: 72px;
  }

  .play-button {
    position: absolute;
    z-index: 3;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
  }
  .img-vbee {
    position: relative;
    top: 5px;
    left: 5px;
  }
`;

const StyledVoicesSearch = styled('div')`
  padding: 0 24px;
  display: flex;
  border-top: 1px solid ${TRANSPARENT_COLOR.borderGray};
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 287px;
  box-sizing: border-box;
  position: relative;

  .header {
    display: flex;
    padding-top: 12px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }

  .title {
    color: ${COLOR.darkGray};
    font-family: "SF Pro";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px
    letter-spacing: -0.4px;
  }

  .reset {
    color: rgba(28, 28, 30, 0.24);
    font-family: "SF Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 510;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.4px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    cursor: pointer;
  }
`;

const StyledSearch = styled(Accordion)`
  width: 100%;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;

  .accordion-sumary {
    display: flex;
    align-items: center;
    gap: 4px;
    align-self: stretch;
  }

  .icon-expandMore {
    width: 24px;
    height: 24px;
  }

  .accordion-name {
    flex: 1;
    color: ${COLOR.black.default};
    font-family: 'SF Pro';
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: -0.4px;
  }

  &.Mui-expanded {
    margin: 0;
  }

  .accordion-expanded {
    margin: 0 !important;
  }

  .MuiAccordionSummary-content {
    margin: 0;
  }

  &::before {
    display: none;
  }

  .search-item-title {
    padding: 0 !important;
    min-height: 0 !important;
  }

  .search-item-content {
    padding: 0;
    display: flex;
    align-items: start;
    gap: 8px;
    flex-wrap: wrap;
    align-self: stretch;
    align-content: start;
  }

  .search-language-item-content {
    padding: 0;
    width: 100%;
    position: relative;
  }
`;

const StyleChooseFilterButton = styled(Button)`
  padding: 12px 16px;
  display: flex;
  ustify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.isChoose ? COLOR.white : COLOR.charcoal};
  border: ${(props) =>
    props.isChoose ? `1px solid ${TRANSPARENT_COLOR.borderGray}` : 'none'};
  border-radius: 500px;
  color: ${(props) =>
    props.isChoose ? COLOR.black.default : COLOR.darkV2[60]};
  &:hover {
    background-color: ${COLOR.white};
    border: 1px solid ${COLOR.darkBlue};
    color: ${COLOR.black.default};
  }

  &:focus {
    background-color: ${COLOR.white};
    border: 1px solid ${COLOR.darkBlue};
  }

  .button-name {
    font-size: 14px;
    font-weight: 510;
    line-height: 16px;
    letter-spacing: -0.4px;
    text-transform: none;
  }
`;

const StyledMobileVoicesFilter = styled(Dialog)`
  .close-button {
    position: absolute;
    right: 0;
  }

  .mobile-filter-voice-wrapper {
    padding: 40px 20px;
  }

  @media only screen and (min-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    display: block;
  }
`;

const StyledVoiceDetail = styled('div')`
  overflow-y: auto;
  overflow-x: hidden;
  height: 500px;

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .title {
    flex: 1;
    font-weight: bold;
  }
`;

const StyledVoiceDetailItem = styled('div')`
  overflow-x: hidden;
  padding-right: 10px;
  margin-bottom: 17px;

  .content {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 4px;
  }

  .detail {
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 12px;
  }

  .male {
    color: ${COLOR.labelBlue};
    background: ${TEXT_BUTTON_COLOR.info.hover};
  }

  .female {
    color: ${COLOR.danger};
    background: ${TEXT_BUTTON_COLOR.error.hover};
  }

  .basicVoice {
    color: ${COLOR.subText};
    background: ${TEXT_BUTTON_COLOR.secondary.hover};
  }

  .proVoice {
    color: ${COLOR.orange};
    background: ${TEXT_BUTTON_COLOR.warning.hover};
  }
`;
const StyledVoiceButtonAction = styled('div')`
  .top-action-detail {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    color: hsl(240, 5%, 48%);
    text-transform: capitalize;
    padding-bottom: 16px;
    padding-top: 16px;
    width: 817px;
  }

  .button-action {
    color: ${COLOR.label2[48]};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    border: 1px solid ${TRANSPARENT_COLOR.borderGray};
    text-transform: none;
    border-radius: 8px;
    &:hover {
      color: ${COLOR.darkBlue};
      border: 1px solid ${TRANSPARENT_COLOR.borderGray};
    }

    &.active {
      color: ${COLOR.darkBlue};
      background: #e0e0e0;
      border: 1px solid ${TRANSPARENT_COLOR.borderGray};
    }
  }
`;

const StyledVoiceFilterAction = styled('div')`
  .search-voice {
    display: flex;
    background-color: white;
    width: 100%;
    max-width: 591px;
    height: 40px;
  }

  .search-voice input {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    height: 25px;
  }

  .img-search {
    font-size: 20px;
    font-weight: bold;
  }
  .header-sort-voice {
    display: flex;
    gap: 24px;
  }
`;

const StyledLanguageButton = styled(Button)`
  display: flex;
  width: 100%;
  gap: 8px;
  justify-content: center;
  align-items: center;
  padding: 8px;
  align-self: stretch;
  border-radius: 480px;
  border: 1px solid ${TRANSPARENT_COLOR.borderGray};
  background: ${COLOR.white};
  text-transform: none;
  &:hover,
  &:focus {
    background-color: inherit;
  }

  .language-button-flag {
    width: 24px;
    height: 24px;
    object-fit: cover;
  }

  .language-button-text {
    flex: 1;
    text-align: start;
    font-family: 'SF Pro';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.darkBlue};
  }
`;

const StyledSelectLanguageDropdown = styled('div')`
  z-index: 1000;
  position: absolute;
  top: 50px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid ${TRANSPARENT_COLOR.borderGray};
  background-color: ${COLOR.white};
  width: 100%;

  .search-language-bar {
    display: flex;
    height: 44px;
    gap: 12px;
    padding: 8px 16px;
    box-sizing: border-box;
    border-bottom: 1px solid ${TRANSPARENT_COLOR.borderGray};
    align-items: center;
  }

  .search-input {
    flex: 1;
    max-width: 171px;
    border: none;
    padding: 0;
    font-family: 'SF Pro';
    font-size: 14px;
    font-weight: 510;
    line-height: 20px;
    color: ${COLOR.indigo[80]};
    letter-spacing: -0.4px;
    &:focus {
      outline: none;
    }
  }

  .dropdown-menu-items {
    display: flex;
    flex-direction: column;
    height: calc(44px * 6);
    overflow-y: auto;

    &::-webkit-scrollbar {
      background-color: ${COLOR.white};
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      height: 85.556px;
      border-radius: 4px;
      background: ${COLOR.white};
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.indigo[64]};
    }
  }
`;

const StyledDropdownMenuItem = styled('div')`
  display: flex;
  padding: 10px 16px;
  gap: 12px;
  align-items: center;
  cursor: pointer;
  border-radius: ${(props) => (props.isChoosed ? '0px' : '8px')};
  background-color: ${(props) =>
    props.isChoosed ? COLOR.indigo[8] : COLOR.white};

  &:hover {
    border-radius: 0px;
    background-color: ${COLOR.indigo[8]};
  }

  .dropdown-item-flag {
    height: 24px;
    width: 24px;
    object-fit: cover;
  }

  .dropdown-item-text {
    flex: 1;
    color: ${COLOR.indigo[80]};
    font-family: 'SF Pro';
    font-size: 14px;
    font-weight: 510;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
`;
const StyledIconButton = styled(IconButton)`
  width: ${({ width }) => width || 'auto'};
  padding: ${({ padding }) => padding || '0px'};
  height: ${({ height }) => height || '10px'};
  border-radius: ${({ borderRadius }) => borderRadius || '100%'};
  border: 1px solid ${COLOR.light};
  border: ${({ hiddenBorder }) => hiddenBorder && 'none'};
  background: ${({ focus }) => focus && TRANSPARENT_COLOR.dark};

  color: ${({ color }) => (color ? COLOR[color] : COLOR.darkBlue)};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.3 : 1)};
  &:hover {
    background: ${({ isDisabled }) =>
      isDisabled ? 'none' : TRANSPARENT_COLOR.dark};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.3 : 1)};
    .icon {
      color: ${({ colorHover }) => COLOR[colorHover]};
    }
  }

  .text-action {
    font-size: 14px;
    color: ${COLOR.darkBlue};
    &:hover {
      color: ${COLOR.black};
    }
  }
  .wrap_btn {
    display: flex;
    width: 180px;
    padding: 8px;
    align-items: center;
    gap: 10px;
  }
  .sort-text {
    flex: 1;
    text-align: left;
  }
  .sort-text {
    color: ${COLOR.indigo};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
  .MuiPaper-root {
    border: 1px solid ${TRANSPARENT_COLOR.borderGray};
    border-radius: 8px;
    box-shadow: none;
  }

  cursor: ${({ isDisabled, cursor }) =>
    isDisabled ? 'default' : cursor || 'pointer'};
`;
const StyledPaper = styled(Paper)`
  border: 1px solid ${TRANSPARENT_COLOR.borderGray};
  border-radius: 8px;
  box-shadow: none;
`;
export {
  StyledVoices,
  StyledVoiceItem,
  StyledSearch,
  StyledMobileVoicesFilter,
  StyledVoiceDetail,
  StyledVoiceDetailItem,
  StyledVoiceButtonAction,
  StyledVoiceFilterAction,
  StyledImg,
  StyledTableScrollbar,
  StyleChooseFilterButton,
  StyledVoicesSearch,
  StyledLanguageButton,
  StyledSelectLanguageDropdown,
  StyledDropdownMenuItem,
  StyledIconButton,
  StyledPaper,
};
